export const LABELS = {
  BACK: 'Atrás',
  CANCEL: 'Cancelar',
  NEXT: 'Siguiente',
};
